import { Routes, Route, useLocation } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { AboutUsPage } from "./pages/AboutUsPage";
import { ServicesPage } from "./pages/ServicesPage";
import { HowItWorksPage } from "./pages/HowItWorksPage";
import { ContactUsPage } from "./pages/ContactUsPage";
import { TermsPage } from "./pages/TermsPage";
import { PrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import { InterestRatePolicyPage } from "./pages/InterestRatePolicyPage";
import { FairPracticeCodePage } from "./pages/FairPracticeCodePage";
import { GrievanceRedressalPage } from "./pages/GrievanceRedressalPage";
import { KycAmlPolicyPage } from "./pages/KycAmlPolicyPage";
import { CorporateGovernancePage } from "./pages/CorporateGovernancePage";
import { RefundPolicyPage } from "./pages/RefundPolicyPage";
import { RiskManagementPolicyPage } from "./pages/RiskManagementPolicyPage";
import { CustomerDataPolicyPage } from "./pages/CustomerDataPolicyPage";
import { ScrollToHash } from "./ScrollToHash";
import { FraudWarningBanner } from "./components/FraudWarningBanner";

function App() {
  const location = useLocation();

  return (
    <>
      <ScrollToHash />
      <div key={location.pathname} className="page-enter">
        <Routes location={location}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/contact-us" element={<ContactUsPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route
            path="/interest-rate-policy"
            element={<InterestRatePolicyPage />}
          />
          <Route
            path="/fair-practice-code"
            element={<FairPracticeCodePage />}
          />
          <Route
            path="/grievance-redressal"
            element={<GrievanceRedressalPage />}
          />
          <Route path="/kyc-aml-policy" element={<KycAmlPolicyPage />} />
          <Route
            path="/corporate-governance"
            element={<CorporateGovernancePage />}
          />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route
            path="/risk-management-policy"
            element={<RiskManagementPolicyPage />}
          />
          <Route
            path="/customer-data-policy"
            element={<CustomerDataPolicyPage />}
          />
          {/* Policies-column "Grievance Redressal Policy" reuses the same
              content as the Legal-column "Grievance Redressal" page. */}
          <Route
            path="/grievance-redressal-policy"
            element={<GrievanceRedressalPage />}
          />
        </Routes>
      </div>
      <FraudWarningBanner />
    </>
  );
}

export default App;
